<div class="gc-panel">
  <p class="gc-panel__hint">{{ hint() }}</p>
  <div class="gc-panel__table" [style.--gc-table-head-top]="braidHeight() + 'px'">
    <!-- Vlecht en kolomkoppen blijven bovenaan staan terwijl de rijen eronder
         schuiven; de kolomkoppen kleven net onder de gemeten vlechthoogte. Ze
         kleven in de scroller van de host (zwevende body of gedockte tab):
         een eigen scroller hier gaf een tweede scrollbalk. -->
    <div #braidSticky class="gc-panel__braid" data-test-id="gc-panel-braid">
      <hd-global-cycles-braid
        selectable
        [highlightPeriodId]="state.periodId()"
        (periodSelected)="state.selectPeriod($event)"
      ></hd-global-cycles-braid>
    </div>
    <hd-global-cycles-table
      selectable
      stickyHead
      [highlightPeriodId]="state.periodId()"
      (periodSelected)="state.selectPeriod($event)"
    ></hd-global-cycles-table>
  </div>
</div>
